module.exports = __webpack_public_path__ + "img/U.S.Bank.c506af3d.svg";